var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.999,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.837,
    cy: 20.162,
    r: 3.577
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.309 11.382h-8.943a4.44 4.44 0 0 0-3.171 1.138 4.44 4.44 0 0 0-1.138 3.171v8.943a4.48 4.48 0 0 0 1.219 3.248c.874.768 2.008 1.175 3.171 1.138h8.862a4.44 4.44 0 0 0 3.171-1.138c.839-.836 1.282-1.989 1.219-3.171v-8.939a4.58 4.58 0 0 0-1.142-3.171c-.867-.839-2.043-1.28-3.248-1.219zm-4.472 14.309a5.53 5.53 0 0 1-5.528-5.529 5.53 5.53 0 0 1 5.528-5.529 5.53 5.53 0 0 1 4.85 8.314 5.53 5.53 0 0 1-4.85 2.743zm5.772-10a1.3 1.3 0 1 1 1.3-1.3c.004.346-.131.679-.376.924s-.577.38-.923.376zM20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20a19.99 19.99 0 0 0-5.853-14.147A19.98 19.98 0 0 0 20 0zm10.65 24.715a6.44 6.44 0 0 1-1.789 4.634 6.33 6.33 0 0 1-4.553 1.707h-8.861a6.33 6.33 0 0 1-4.553-1.707c-1.224-1.223-1.874-2.906-1.789-4.634v-8.943c-.095-1.709.543-3.378 1.753-4.588s2.879-1.848 4.588-1.753h8.944a6 6 0 0 1 6.26 6.341v8.943z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.458ab19bea9a6f57f8572b3986a65988.svg";
export { ForwardRef as ReactComponent };